import { forwardRef, type Ref, type SVGProps } from "react";
const IconBuildingsFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M26.72 6.82 14.36 2.07a1 1 0 0 0-.93.11A1 1 0 0 0 13 3v9H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V8.69a2 2 0 0 0-1.28-1.87M12 26H9a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2m0-4H9a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2m0-4H9a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2m8 7a1 1 0 0 1-2 0V10a1 1 0 0 1 2 0Zm4 0a1 1 0 0 1-2 0V12a1 1 0 0 1 2 0Z" />
  </svg>
);
const ForwardRef = forwardRef(IconBuildingsFilledSVG);
ForwardRef.displayName = "IconBuildingsFilled";
export { ForwardRef as IconBuildingsFilled };
